import { Text } from "@fragments";
import AvailabilityInPlan from "@components/AvailabilityInPlan";
import { DiamondRounded } from "@mui/icons-material";
import { normalizeAvailabilityForForm } from "../../enums";
import "./styles.scss";

export default function Availability({ configRef, onAvailabilityChange }) {
    const normalizedAvailability =
        normalizeAvailabilityForForm(configRef.current?.availability) ?? null;

    return (
        <>
            <Text.h3 left={<DiamondRounded />} value="Disponibilidade do material" className="mt-3"/>

            <AvailabilityInPlan
                community={configRef.current?.community}
                initialValues={normalizedAvailability}
                onChange={onAvailabilityChange}
                className="mt-1"
            />
        </>
    );
}
